import "./styles/HelpModalWindow.css";
import { ModalWindow } from "../Components/ModalWindow";
import { ReactNode } from "react";
import { StyledFlexConteiner } from "../Components/StyledComponents/Containers";
import { CrossDefaultButton } from "../Components/IconButtons";

export const HelpModalWindow: React.FC<{
  onCloseClick: () => void;
  cards: ReactNode; // TODO: cards -> pivots
  windowClassName?: string;
}> = ({ onCloseClick, cards, windowClassName }) => {
  return (
    <ModalWindow height="100vh">
      <StyledFlexConteiner $jc="flex-start" width="100%">
        <CrossDefaultButton onClick={onCloseClick} />
        {/* TODO: Put the pivot title here */}
      </StyledFlexConteiner>
      <div className={`${windowClassName ? windowClassName : ""} help-cards`}>
        {cards}
      </div>
    </ModalWindow>
  );
};
